import { getGenericFormInitialValues } from "../../../components/form/utils/initialValues";

export const getBmsCopayLsFormInitialValues = ({ applicationForm, formJson }) => {
  const initialValues = getGenericFormInitialValues(applicationForm, formJson);

  return initialValues;
};
